import React from 'react';
import { ExternalLink } from '@lifeomic/chromicons';
import { IconButtonLink } from '@lifeomic/chroma-react/components/IconButtonLink';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import urls from '../../util/urls';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  openLink: {
    id: 'externalLinkButton.displayopenLinkName',
    defaultMessage: 'Open Link',
  },
});

export interface ExternalLinkButtonOwnProps {
  projectId: string;
  accountId: string;
  fileId: string;
  tooltipText?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export type ExternalLinkButtonProps = ExternalLinkButtonOwnProps;

const ExternalLinkButton = (props: ExternalLinkButtonProps) => {
  const { formatMessage } = useIntl();

  const button = (
    <IconButtonLink
      aria-label={formatMessage(messages.openLink)}
      icon={ExternalLink}
      target="_blank"
      to={urls.app.files({
        fileId: props.fileId,
        account: props.accountId,
        projectId: props.projectId,
      })}
      size={0}
      onClick={props.onClick}
    />
  );

  if (props.tooltipText) {
    return (
      <Tooltip title={props.tooltipText} placement="bottom">
        {button}
      </Tooltip>
    );
  } else {
    return button;
  }
};

export default React.memo(ExternalLinkButton);
